module.exports = __webpack_public_path__ + "img/Monte_Kope_96.bb2d7e96.jpg";